module.exports = __webpack_public_path__ + "img/live-drop-522880faca626c5a553bb54357f4ac6e.15b5f493.png";